module.exports = __webpack_public_path__ + "icon_file_download-e5c29678f3a639e1e62374911d85e1d0.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_file_download.png
// module id = 275
// module chunks = 86